<template>
  <v-container fluid>
    <v-card elevation="0" flat>
      <v-toolbar color="#eeeeee" tile flat dense>
        <h3 class="title"></h3>
        <v-spacer />
        <v-tooltip bottom color="primary">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" :to="`/biddings-contracts/create/${bidding_id}`">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>Adicionar</span>
        </v-tooltip>
        <v-tooltip bottom color="primary">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" @click="showSearch =!showSearch">
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </template>
          <span>Pesquisar</span>
        </v-tooltip>
        <v-footer absolute color="primary" dark v-if="showSearch">
          <v-text-field
            class="search-field"
            v-model="search"
            color="#fff"
            placeholder="pesquisar"
            prepend-inner-icon="mdi-magnify"
            append-outer-icon="mdi-close"
            @click:append-outer="[showSearch = !showSearch,search = '']"
          />
        </v-footer>
      </v-toolbar>

      <v-card-actions>
        <v-data-table
          :headers="headers"
          :items="data"
          :search="search"
          :items-per-page="8"
          :loading="loader"
          loading-text="CARREGANDO..."
          class="elevation-0 maxPage"
        >
          <template v-slot:item.contract_value="{ item }">
            <span>{{realMask(item.contract_value.toFixed(2))}}</span>
          </template>
          <template v-slot:item.contract_start_term="{ item }">
            <span>{{item.contract_start_term && formatDateBr(item.contract_start_term)}}</span>
          </template>
          <template v-slot:item.contract_end_term="{ item }">
            <span>{{item.contract_end_term && formatDateBr(item.contract_end_term)}}</span>
          </template>
          <template v-slot:item.action="{ item }">
            <v-tooltip bottom color="primary">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  small
                  class="mr-2"
                  @click="$router.push(`/biddings-contracts/edit/${item.contract_id}/${bidding_id}`)"
                  color="primary"
                >mdi-pencil</v-icon>
              </template>
              <span>Editar</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card-actions>
    </v-card>
    <v-snackbar multi-line :color="snack.color" v-model="snack.show" transition="fade-transition">
      {{snack.message}}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snack.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  props: ["bidding_id", "prefecture_id"],
  data() {
    return {
      search: "",
      loader: true,
      showSearch: false,
      data: [],
      snack: {
        show: false,
        message: "",
        color: ""
      },
      headers: [
        {
          text: "Número",
          align: "start",
          sortable: false,
          value: "contract_number"
        },
        { text: "Licitaçāo", value: "bidding_process_number" },
        { text: "Participante", value: "provider_name" },
        { text: "Vl. do Contrato", value: "contract_value" },
        { text: "Data de Inicio", value: "contract_start_term" },
        { text: "Data de Termino", value: "contract_end_term" },
        { text: "Ações", align: "right", value: "action", sortable: false }
      ]
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    realMask(value) {
      value = value.replace(/\D/g, ""); // permite digitar apenas numero
      value = value.replace(/(\d{1})(\d{14})$/, "$1.$2"); // coloca ponto antes dos ultimos digitos
      value = value.replace(/(\d{1})(\d{11})$/, "$1.$2"); // coloca ponto antes dos ultimos 11 digitos
      value = value.replace(/(\d{1})(\d{8})$/, "$1.$2"); // coloca ponto antes dos ultimos 8 digitos
      value = value.replace(/(\d{1})(\d{5})$/, "$1.$2"); // coloca ponto antes dos ultimos 5 digitos
      value = value.replace(/(\d{1})(\d{1,2})$/, "$1,$2"); // coloca virgula antes dos ultimos 2 digitos
      return value;
    },
    formatDateBr(date) {
      return date
        .substr(0, 10)
        .split("-")
        .reverse()
        .join("/");
    },
    initialize() {
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);
      this.$http
        .get(`/biddings/contracts/${this.bidding_id}`)
        .then(r => {
          this.data = r.data;
          this.loader = false;
          this.$store.dispatch("setLoader", this.loader);
        })
        .catch(e => {
          this.loader = false;
          this.snack.show = true;
          this.snack.message = e;
          this.snack.type = "error";
          this.$store.dispatch("setLoader", this.loader);
        });
    },
    deleteItem(id) {
      let c = confirm("Deseja excluir o registro?");
      if (c) {
        this.$store.dispatch("setLoader", true);
        this.$http
          .delete(`/biddings/contracts/${id}`)
          .then(r => {
            this.snack.show = true;
            this.snack.message = r.data.result;
            this.snack.color = "success";
            this.initialize();
          })
          .catch(e => {
            this.snack.show = true;
            this.snack.message = e.message;
            this.snack.color = "error";
            this.$store.dispatch("setLoader", false);
          });
      }
    }
  }
};
</script>

<style scoped>
.top-bar {
  padding: 30px 15px;
}
.title {
  text-transform: uppercase;
  font-weight: 400;
}
.maxPage {
  width: 100%;
}
.search-field {
  margin-top: 10px;
}
.space {
  margin: 0 10px;
}
</style>